import React, { useState, useEffect } from "react";
import FrameImg from "../../assets/icons/Frame1663.png";
import backup from "../../assets/icons/backup.png";
import database from "../../assets/icons/database.png";
import AWS from "../../assets/icons/aws.png";
import clarityHelp from "../../assets/icons/clarity_help.png";
import AddIcon from "@material-ui/icons/Add";
import Button from "@material-ui/core/Button";
import { Typography } from "@material-ui/core";
import { useStyles, IOSSlider } from "./CreateServiceStyle";
import Card from "../../components/card/Card";
import ram from '../../assets/icons/ram.png';
import storage from '../../assets/icons/storage.png';
import cpu from '../../assets/icons/cpu.png';
import ServiceTabOne from '../../components/tabs/serviceTabs/ServiceTabOne/ServiceTabOne';
import ServiceTabTwo from '../../components/tabs/serviceTabs/ServiceTabTwo/ServiceTabTwo';

export default function CreateService() {
  const classes = useStyles();

  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const updateSize = () =>
    setSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  useEffect(() => (window.onresize = updateSize), []);

  const [service, setService] = useState("");

  return (
    <>
      <Typography
        variant="h4"
        component="div"
        noWrap={true}
        className={classes.mainTitle}
      >
        Create Service
      </Typography>
      <div
        style={{ width: size.width < 960 ? "100%" : size.width - 330 }}
        className={classes.root}
      >
        <div className={classes.MainDiv}>
          <div className={classes.MainContainer}>
            <div className={classes.cardContainer}>
              <Typography
                variant="h6"
                component="div"
                noWrap={true}
                className={classes.serviceText}
              >
                1. Select your service
              </Typography>
              <Card />
            </div>

            <div className={classes.imgsContainer}>
              <Typography
                variant="h6"
                component="div"
                noWrap={true}
                className={classes.serviceText}
              >
                2. Select your Services
              </Typography>

              <div
                onClick={() => setService("aws")}
                className={classes.serviceContainer}
              >
                <div
                  className={
                    service === "aws"
                      ? classes.awsServiceActive
                      : classes.awsService
                  }
                />
                <div
                onClick={() => setService("google")}
                className={
                  service === "google"?
                  classes.googleServiceActive:
                  classes.googleService

                }
                   />
                <div className={classes.microsoftService} />
                <div className={classes.digitalService} />
                <div className={classes.upcloudService} />
              </div>
            </div>

            {/* Tabs */}
            <div className={classes.selectServiceContainer}>
              <Typography
                variant="h6"
                component="div"
                noWrap={true}
                className={classes.serviceText}
              >
                3. Select your Services
              </Typography>
              <div>
                <ServiceTabOne />
              </div>
            </div>

            <div className={classes.planServiceContainer}>
              <Typography
                variant="h6"
                component="div"
                noWrap={true}
                className={classes.serviceText}
              >
                4. Select Service Plan
              </Typography>
              <ServiceTabTwo />
            </div>

            <div className={classes.planServiceContainer}>
              <Typography
                variant="h6"
                component="div"
                noWrap={true}
                className={classes.serviceText}
              >
                5. Additional Disk Space
              </Typography>

              <div className={classes.diskSpaceContainer}>
                <div className={classes.diskSpaceSlider}>
                  <p className={classes.diskSpacetext}>
                    Use slider to add extra disk capacity:
                  </p>
                  <div className={classes.iosSlider}>
                    <div className={classes.customThumbnailOne} />

                    <IOSSlider
                      className={classes.slider}
                      style={{ width: "100%" }}
                      aria-label="ios slider"
                      defaultValue={60}
                      valueLabelDisplay="on"
                    />

                    <div className={classes.customThumbnailTwo} />
                  </div>
                </div>
                <div className={classes.diskSpaceSliderRight}>
                  <p className={classes.diskSpaceSliderRightText}>
                    No extra disk space selected
                  </p>
                </div>
              </div>
            </div>

            <div className={classes.planServiceContainer}>
              <Typography
                variant="h6"
                component="div"
                noWrap={true}
                className={classes.serviceText}
              >
                6. Provide Service Name
              </Typography>
              <div className={classes.mainInfo}>
                <div className={classes.infoContainer}>
                  <div className={classes.imginfoDiv}>
                    <img src={clarityHelp} width={36} height={36} alt="img" />
                  </div>
                  <div className={classes.textinfoDiv}>
                    <p className={classes.infoTopText}>Note</p>
                    <p className={classes.infoBottomText}>
                      The service name cannot be changed afterwards.
                    </p>
                  </div>
                </div>
                <p className={classes.companyName}>Compnay Name</p>
                <input
                  className={classes.infoInput}
                  type={"text"}
                  value={"Company here 253.01"}
                />
                <p className={classes.infoBottomText}>
                  Conveniently embrace ethical ideas whereas focused core
                  competencies. Rapidiously enable integrated results after
                  front-end intellectual capital.{" "}
                </p>
              </div>
            </div>
          </div>

          {/* Summary Section */}
          <div className={classes.summaryContainer}>
            <p className={classes.summaryHeader}>Service Summary</p>
            <div className={classes.summaryInnerContainer}>
              <div className={classes.summaryOne}>
                <p className={classes.p_Tag_Head}>Name</p>
                <p className={classes.p_Tag}>Kafka-17df67d9</p>
              </div>

              <div className={classes.summaryTwo}>
                <p className={classes.p_Tag_Head}>Service</p>
                <div className={classes.summaryTwoInner}>
                  <img
                    src={FrameImg}
                    width={24}
                    height={24}
                    style={{ marginRight: 6 }}
                    alt="img"
                  />
                  <p className={classes.p_Tag}>Apache Kafka 3.1</p>
                </div>
              </div>

              <div className={classes.summaryTwo}>
                <p className={classes.p_Tag_Head}>Cloud</p>
                <div className={classes.summaryTwoInner}>
                  <img
                    src={AWS}
                    width={24}
                    height={24}
                    style={{ marginRight: 6 }}
                    alt="img"
                  />
                  <p className={classes.p_Tag}>Amazon Web Services</p>
                </div>
              </div>

              <div className={classes.summaryTwo}>
                <p className={classes.p_Tag_Head}>Region</p>
                <p className={classes.p_Tag}>
                  United States, Ohio-Amazon Web Services:Ohio
                </p>
              </div>

              <div className={classes.summaryTwo}>
                <p className={classes.p_Tag_Head_Price}>Plan</p>
                <p className={classes.p_Tag_Head}>Business-4</p>
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  <div className={classes.businessSummary}>
                    <img
                      src={cpu}
                      width={11}
                      height={11}
                      style={{ marginRight: 6 }}
                      alt="img"
                    />
                    <p className={classes.p_Tag}>2 CPU</p>
                  </div>

                  <div className={classes.businessSummary}>
                    <img
                      src={ram}
                      width={11}
                      height={11}
                      style={{ marginRight: 6 }}
                      alt="img"
                    />
                    <p className={classes.p_Tag}>4 GB RAM</p>
                  </div>
                  <div className={classes.businessSummary}>
                    <img
                      src={storage}
                      width={11}
                      height={11}
                      style={{ marginRight: 6 }}
                      alt="img"
                    />
                    <p className={classes.p_Tag}>600 GB Storage</p>
                  </div>
                  <div className={classes.businessSummary}>
                    <img
                      src={database}
                      width={11}
                      height={11}
                      style={{ marginRight: 6 }}
                      alt="img"
                    />
                    <p className={classes.p_Tag}>No Backups</p>
                  </div>
                  <div className={classes.businessSummaryEnd}>
                    <img
                      src={backup}
                      width={11}
                      height={11}
                      style={{ marginRight: 6 }}
                      alt="img"
                    />
                    <p className={classes.p_Tag}>
                      3- Node High Availability Set
                    </p>
                  </div>
                </div>
              </div>

              <div className={classes.summaryTwo}>
                <p className={classes.p_Tag_Head}>Additional disk storage</p>
                <p className={classes.p_Tag}>None</p>
              </div>

              <div
                style={{ borderBottom: "none" }}
                className={classes.summaryTwo}
              >
                <p className={classes.p_Tag_Head_Price}>
                  Estimated Monthly Price*
                </p>
                <p className={classes.p_Tag_Price}>$660 USD</p>
                <p className={classes.p_Tag}>
                  Estimated Monthly Price is based on 730 hours of usage.
                </p>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  className={classes.customBtn}
                  startIcon={<AddIcon className={classes.addIcon} />}
                >
                  Create new service
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
